<template>
  <div class="ime-simple-quote" :class="obj.classes">
    <div class="row">
      <!--Span 4, 6 or FW -->
      <div class="quote-cntnr" :class="objP.quoteContainer">
        <p
          class="quote-text"
          :class="objP.quoteTextAlignment"
          v-html="objC.quote"
          :data-aos="aos('quote', 'type')"
          :data-aos-duration="aos('quote', 'duration')"
          :data-aos-delay="aos('quote', 'delay')">
        </p>
        <p
          class="quote-citation"
          v-if="objP.hascitelink"
          :data-aos="aos('quoteCitation', 'type')"
          :data-aos-duration="aos('quoteCitation', 'duration')"
          :data-aos-delay="aos('quoteCitation', 'delay')">
          <a :href="objC.citelink" v-html="objC.quoteCitation"></a>
        </p>
        <p class="quote-citation"
           v-else v-html="objC.quoteCitation"
           :data-aos="aos('quoteCitation', 'type')"
           :data-aos-duration="aos('quoteCitation', 'duration')"
           :data-aos-delay="aos('quoteCitation', 'delay')"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleQuote",
  props: {
    obj: Object
    // {
    //   type: 'SimpleQuote', // String - component name
    //   variant: '', // String - class names for any variants
    //   classes: '', // String - any extra classes needing to be added
    //   transitions: {
    //     // Fill out if we are using aos.
    //     // Can do any other visible content item, like subtitle or graphic.
    //     // Content: quote and quoteCitation
    //     // Attributes: type, duration, and delay
    //     aos: {
    //       quote: {
    //         type: 'fade-left',
    //         duration: 2000
    //       },
    //       quoteCitation: {
    //         type: 'fade-right',
    //         delay: 500
    //       }
    //     },
    //     gsap: {
    //       components: [], // Array - of elements to animate
    //       script: '' // String - link to component specific script files
    //     }
    //   },
    //   presentation: {
    //    quoteTextAlignment: 'text-right', // String - Choose from text-left, text-center or text-right
    //    quoteContainer: 'col-xl-4 col-lg-4 col-md-12 col-sm-12', // String of bootstrap class names
    //    hascitelink: false,
    //   },
    //   content: {
    //    quote: '', // String
    //    quoteCitation: '', // String
    //    citelink: '' // String - URL
    //  }
    // }
  },
  methods: {
    aos(content, attr) {
      // safe traversal, we don't have to define every attribute in the store.
      // Same thing as dog?.action?.bark in other languages.
      return ((this.obj.transitions.aos || {})[content] || {})[attr] || null;
    }
  },
  computed: {
    objP() {
      return this.obj.presentation;
    },
    objC() {
      return this.obj.content;
    }
  }
};
</script>


<style lang="scss">
  .ime-simple-quote {
    blockquote {
      padding: 20px;
      cite {
        display: block;
      }
    }
  }
</style>
